import { useEffect, useRef, useState } from "react"
import AdminNavBar from "./AdminNavBar"
import LocationNavBar from "./LocationNavBar"

const EditLocation = () => {
	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}
	
	var locationRef = useRef<HTMLSelectElement>(null)

	const [locations, setLocations] = useState<Location[]>([])
	const [selectedLocation, setSelectedLocation] = useState<Location>({ id: 0, short_name: "", long_name: "" })
	const [isVisible, setIsVisible] = useState(false)
	const [locationShortName, setLocationShortName] = useState("")
	const [locationLongName, setLocationLongName] = useState("")
	const [msg, setMsg] = useState("")

	const handleSelectChange = async () => {
		if (locationRef && locationRef.current) {
			const id = locationRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/locationByID?id=" + id);
			const location = await response.json()
			setSelectedLocation(location)
			setLocationShortName(location.short_name)
			setLocationLongName(location.long_name)
			setIsVisible(true)
			setMsg("")
		}
	}

	const handleSubmit = async () => {
		if (locationShortName === "" || locationLongName === "") {
			setMsg("Location short name and long name cannot be empty")
			return
		}
		var formData = new FormData()
		if (locationRef && locationRef.current) {
			formData.append("id", locationRef.current.value)
		}
		formData.append("short_name", locationShortName)
		formData.append("long_name", locationLongName)
		
		const resp = await fetch(process.env.REACT_APP_API+"/api/locations", {
			method: "PUT",
			body: formData
		});
		if (resp.status === 200) {
			setMsg("Updated "+ locationShortName + " successfully")
		} else {
			setMsg("Failed to update " + locationShortName)
		}
		setLocationLongName("")
		setLocationShortName("")
		if (locationRef && locationRef.current) {
			locationRef.current.value = ""
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}

	useEffect(() => {
		getLocations()
		if (selectedLocation && selectedLocation.id && selectedLocation.id > 0){
			setLocationShortName(selectedLocation.short_name)
			setLocationLongName(selectedLocation.long_name)
		}
	}, [selectedLocation])

	return (
		<div className="resilire">
			<AdminNavBar />
			<LocationNavBar />
			<h3>Edit Location</h3>
			<select id="units" onChange={handleSelectChange} ref={locationRef}>
				<option value=""></option>
				{locations.map((location) => (
					<option value={location.id} key={location.id}>{location.long_name}</option>
				))}
			</select>
			{isVisible && (
				<div className="resilire">
			<label htmlFor="locationShortName">Location Short Name: </label>
			<input id="locationShortName" type="text" value={locationShortName} onChange={(e) => setLocationShortName(e.target.value)} />
			<label htmlFor="locationLongName">Location Long Name: </label>
			<input id="locationLongName" type="text" value={locationLongName} onChange={(e) => setLocationLongName(e.target.value)} />
				<button onClick={handleSubmit}>Submit</button>
				</div>
			)}
			<p>{msg}</p>
		</div>
	)
}

export default EditLocation;
